import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { PracticalInformationEditionFormWrapper } from 'src/Components/Forms/PracticalInformation/PracticalInformationEditionFormWrapper';

type PracticalInformationParams = {
  practicalInformationId: string;
};

const EditPracticalInformationDrawer = () => {
  const { t } = useTranslation();
  const { practicalInformationId } = useParams<PracticalInformationParams>();

  if (!practicalInformationId) {
    return <Navigate to="/guides" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('editEventForm.editEvent', "Modifier l'information pratique")}>
      {({ onClose }) => (
        <PracticalInformationEditionFormWrapper
          onCreate={onClose}
          onCancel={onClose}
          practicalInformationId={practicalInformationId}
        />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default EditPracticalInformationDrawer;
